import { Form } from "antd";
import { HeaderOverview } from "components";
import { Wrapper } from "pages/overview";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetPropertyDashboardAppTeamUp } from "service/dashboard/property/overview";
import { SpaceStyle } from "..";

const TeamUpApp = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();

  const teamUpAppPropertyDate = Form.useWatch("teamUpAppPropertyDate");
  const date = findDate(teamUpAppPropertyDate, "month");

  const data = useGetPropertyDashboardAppTeamUp({
    ...date,
  });

  return (
    <Wrapper className="h-[300px]">
      <HeaderOverview
        title={t("number-of-user-using-app-team-up")}
        name="teamUpAppPropertyDate"
      />
      <SpaceStyle className="center " direction="vertical">
        <div className="count"style={{fontSize:"36px"}}>{`${data.data || "0"}`}</div>
        <div className="people"style={{fontSize:"24px"}}>{t("people")}</div>
      </SpaceStyle>
    </Wrapper>
  );
};

export default TeamUpApp;
